import { render, staticRenderFns } from "./Tarifrechner.vue?vue&type=template&id=3511337e"
import script from "./Tarifrechner.vue?vue&type=script&lang=js"
export * from "./Tarifrechner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports